import React from 'react'
import { HomeWelcome } from 'src/components/HomePage/HomeWelcome/HomeWelcome'
import { Transaction } from 'src/components/HomePage/ModalsContent/Transaction/Transaction'
import { useTypedSelector } from 'src/redux/index'
import {
  CallToActionHomeCard,
  HomePageWrapper,
  LeftHomePageComponent,
} from './homePageStyle'
import { HomeQuickSaveBtn } from 'src/components/Global/Button/Button'
import { Link, useLocation } from 'react-router-dom'
import { LinkArrowSvg, one, two } from 'src/assets'
import SEO from 'src/seo'

const Homepage = () => {
  const investmentData = useTypedSelector((state) => state.invest.all?.plans!)
  const recent = investmentData?.slice(1, 2)
  return (
    <HomePageWrapper>
      <SEO title="Home" />
      <LeftHomePageComponent>
        <HomeWelcome />
        <div className="home">
          <Transaction />
          {recent?.map((item: any) => (
            <CallToActionHomeCard>
              <div className="header_img">
                <img src={item.image} alt="" className="image" />
              </div>

              <div className="card_body">
                <p className="title_user">{item.plan_name}</p>
                <div className="card_text_link">
                  <p>{item.description.substring(0, 60)}...</p>
                  <Link to="/invest" className="call_to_action_link">
                    Join other investors
                    <span>
                      <img src={LinkArrowSvg} alt="" />
                    </span>
                  </Link>
                </div>
              </div>
            </CallToActionHomeCard>
          ))}
        </div>
      </LeftHomePageComponent>
    </HomePageWrapper>
  )
}
export { Homepage }
